var map = {
	"./1.png": 4843,
	"./10.png": 4525,
	"./11.png": 65787,
	"./12.png": 33869,
	"./13.png": 75087,
	"./14.png": 33988,
	"./15.png": 15601,
	"./16.png": 93932,
	"./17.png": 59246,
	"./18.png": 40523,
	"./19.png": 95635,
	"./2.png": 32354,
	"./20.png": 12773,
	"./3.png": 59734,
	"./4.png": 68469,
	"./5.png": 24742,
	"./6.png": 8972,
	"./7.png": 67092,
	"./8.png": 8315,
	"./9.png": 4544,
	"./blog-details/1.png": 95105,
	"./blog-details/2.png": 37966
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20211;